/* Lenavy productkaarten: door de foto's swipen zonder de pagina te verlaten (28-10-2026, ronde 5).
   Leest span.th-card-imgs (uit snippets/price.liquid) en legt over de kaartfoto een strook met alle foto's.
   Telefoon: swipen. Computer: pijltjes bij hover. Klik op een kleurbolletje springt naar die kleur.
   Klik op een foto opent het product. Werkt ook voor kaarten die later verschijnen (filters, tabbladen).
   Het label "Bespaar xx%" wordt in de foto gezet, zodat het altijd even ver uit de hoek staat.
   04-11-2026 (zoals Smidcom-standaard): een swipe gaat altijd precies een foto verder, hoe hard er ook wordt geswipet.
   - Telefoon: scroll-snap-stop: always op elke foto.
   - Trackpad/muis (wheel): de horizontale beweging wordt met preventDefault afgevangen. Na de eerste beweging gaat
     de kaart een foto verder; de naloop van dezelfde swipe wordt genegeerd tot die is uitgedempt (180 ms stil,
     of een nieuwe, duidelijk sterkere beweging na 350 ms). Verticaal scrollen blijft gewoon werken. */
(function () {
  var st = document.createElement('style');
  st.textContent = '.card-wrapper.has-th-swipe .card__heading a::after{pointer-events:none}.card-wrapper .card__media > .th-card-pct{z-index:6}.card-wrapper .th-swipe__slide{scroll-snap-stop:always}';
  document.head.appendChild(st);
  function file(u) { return String(u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*\./, '.'); }
  function sized(u, w) {
    u = String(u || '');
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function attr(s) { return String(s || '').replace(/"/g, '&quot;'); }
  function moveLabel(card) {
    var pct = card.querySelector('.th-card-pct'), media = card.querySelector('.card__media');
    if (pct && media && pct.parentElement !== media) media.appendChild(pct);
  }
  function build(card) {
    moveLabel(card);
    if (card.dataset.thSwipe) return;
    var data = card.querySelector('.th-card-imgs'); if (!data) return;
    var urls = (data.dataset.imgs || '').split('|').filter(Boolean); if (urls.length < 2) return;
    var media = card.querySelector('.card__media'); if (!media) return;
    card.dataset.thSwipe = '1';
    var href = data.dataset.url || '#';
    var orig = media.querySelector('img');
    var sizes = (orig && orig.getAttribute('sizes')) || '(min-width: 990px) 25vw, calc((100vw - 35px) / 2)';
    function imgTag(u, i) {
      var src, srcset;
      if (i === 0 && orig && orig.getAttribute('srcset') && file(orig.getAttribute('src')) === file(u)) {
        src = orig.getAttribute('src'); srcset = orig.getAttribute('srcset');
      } else {
        src = sized(u, 360);
        srcset = [180, 360, 540, 720].map(function (w) { return sized(u, w) + ' ' + w + 'w'; }).join(', ');
      }
      return '<img src="' + attr(src) + '" srcset="' + attr(srcset) + '" sizes="' + attr(sizes) + '" alt="" loading="lazy" decoding="async" draggable="false">';
    }
    var box = document.createElement('div'); box.className = 'th-swipe';
    box.innerHTML = '<div class="th-swipe__track">' + urls.map(function (u, i) {
      return '<a class="th-swipe__slide" href="' + href + '" tabindex="-1" aria-hidden="' + (i ? 'true' : 'false') + '">' + imgTag(u, i) + '</a>';
    }).join('') + '</div>' +
      '<button type="button" class="th-swipe__arrow th-swipe__arrow--prev" aria-label="Vorige foto"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="th-swipe__arrow th-swipe__arrow--next" aria-label="Volgende foto"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="th-swipe__dots" aria-hidden="true">' + urls.map(function (u, i) { return '<span' + (i ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>';
    media.insertBefore(box, media.querySelector('.th-card-pct'));
    card.classList.add('has-th-swipe');
    var track = box.querySelector('.th-swipe__track');
    var dots = box.querySelectorAll('.th-swipe__dots span');
    track.style.scrollSnapType = 'x mandatory';
    track.querySelectorAll('.th-swipe__slide').forEach(function (sl) { sl.style.scrollSnapAlign = 'start'; sl.style.scrollSnapStop = 'always'; });
    var cur = 0, moving = false;
    function w() { return Math.max(1, track.clientWidth); }
    function idx() { return Math.round(track.scrollLeft / w()); }
    function go(i) { i = Math.max(0, Math.min(urls.length - 1, i)); cur = i; moving = true; track.scrollTo({ left: i * w(), behavior: 'smooth' }); }
    var t; track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var k = idx(); cur = k; moving = false; dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); }, 60);
    }, { passive: true });
    /* Wheel (trackpad, muis): precies een foto per swipe, naloop negeren, verticaal scrollen niet blokkeren */
    var wheelLock = false, wheelSum = 0, wheelLast = 0, wheelAt = 0, wheelT;
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      var size = Math.abs(e.deltaX), now = Date.now();
      clearTimeout(wheelT);
      wheelT = setTimeout(function () { wheelLock = false; wheelSum = 0; wheelLast = 0; }, 180);
      if (wheelLock && now - wheelAt > 350 && size > wheelLast + 12) { wheelLock = false; wheelSum = 0; }
      wheelLast = size;
      if (wheelLock) return;
      wheelSum += e.deltaX;
      if (Math.abs(wheelSum) < 30) return;
      wheelLock = true; wheelAt = now;
      go((moving ? cur : idx()) + (wheelSum > 0 ? 1 : -1));
    }, { passive: false });
    box.querySelector('.th-swipe__arrow--prev').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go((moving ? cur : idx()) - 1); });
    box.querySelector('.th-swipe__arrow--next').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go((moving ? cur : idx()) + 1); });
    var files = urls.map(file);
    card.querySelectorAll('.th-card-sw [data-img]').forEach(function (sw) {
      function pick(e) { e.preventDefault(); e.stopPropagation(); var k = files.indexOf(file(sw.dataset.img)); if (k > -1) go(k); card.querySelectorAll('.th-card-sw > span').forEach(function (s) { s.classList.toggle('is-active', s === sw); }); }
      sw.addEventListener('click', pick);
      sw.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') pick(e); });
    });
  }
  function scan(root) { (root || document).querySelectorAll('.card-wrapper').forEach(build); }
  function start() {
    scan();
    var q; new MutationObserver(function (list) { for (var i = 0; i < list.length; i++) { if (list[i].addedNodes.length) { clearTimeout(q); q = setTimeout(scan, 50); return; } } }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
